'use client';

import cn from 'clsx';
import s from './PatternLanguageIntro.module.css';
// @ts-ignore
import { usePathname } from 'next/navigation';

export type LanguageIntroProps = {
    context: string | null;
    sub_context?: string | null;
    content: string | null;
    border?: boolean;
    narrow?: boolean;
    no_bottom_padding?: boolean;
    text_style?: 'mmds-subtitle-one' | 'mmds-copy-para-serif';
};

export const PatternLanguageIntro = ({
    context,
    sub_context,
    content,
    border = true,
    narrow = false,
    no_bottom_padding = false,
    text_style = 'mmds-subtitle-one',
}: LanguageIntroProps) => {
    if (!content) return null;
    const pathname = usePathname();
    const hasBundlesPath = pathname.startsWith('/bundles');
    let textStyleWithFallback = 'mmds-subtitle-one';
    if (
        typeof text_style == 'string' &&
        ['mmds-subtitle-one', 'mmds-copy-para-serif'].includes(text_style)
    ) {
        textStyleWithFallback = text_style;
    }
    return (
        <div
            className={cn(s.root, s.stack, {
                [s.border]: border,
                [s.narrow]: narrow,
                [s.noBottomPadding]: no_bottom_padding,
            })}
        >
            <div className={s.header}>
                {hasBundlesPath ? (
                    <h1 className="mmds-component-one-detail">{context}</h1>
                ) : (
                    <h3 className="mmds-component-one-detail">{context}</h3>
                )}
                {sub_context && (
                    <p className={cn(s.subCount, 'mmds-copy-three-detail')}>
                        {sub_context}
                    </p>
                )}
            </div>
            <p
                className={cn(s.description, {
                    'mmds-subtitle-one':
                        textStyleWithFallback === 'mmds-subtitle-one',
                    'mmds-copy-para-serif':
                        textStyleWithFallback === 'mmds-copy-para-serif',
                })}
            >
                {content}
            </p>
        </div>
    );
};

export default PatternLanguageIntro;
